export default __webpack_public_path__ + "static/media/clipboard.5a2f71d0.svg";